import React from 'react'
import { useTranslation } from 'react-i18next'
import { MdOutlineCancel } from 'react-icons/md'
import { APP_TYPE } from '../../../../utils/constants/UIConstants'
import ATRadioButton from '../../../common/radioButton/ATRadioButton'
import ATTextButton from '../../../common/formComponent/ATTextButton'
import ATSearchBox from '../../../common/formComponent/ATSearchBox'
import { useAddCustomerRolesHooks } from '../../../../customHooks/usermanagement/useAddCustomerRolesHooks'
import {
  ApplicationTypesData,
  customersListData,
} from '../../../../interface/response/UserRolesResponse'
import { useAddUpdateUserHooks } from '../../../../customHooks/usermanagement/useAddUpdateUserHooks'

interface AddCustomerRolesProps {
  backButtonHandler: () => void
  continueButtonHandler: () => void
  onCloseModal: () => void
  getRoleList: ApplicationTypesData[]
  isEdit: boolean
  userId?: string
}

const AddCustomerRoles = ({
  backButtonHandler,
  onCloseModal,
  getRoleList,
  isEdit,
  userId,
}: AddCustomerRolesProps) => {
  const { t } = useTranslation(['translation'])
  const {
    selectedData,
    selectedAppCode,
    userRoles,
    applicationTypes,
    customersList,
    selectedCustomer,
    handleAppSelection,
    queryHandler,
    handleCustomerSelection,
    filteredJobs,
    removeSelection,
    checkSelection,
    selectedApps,
    query,
  } = useAddCustomerRolesHooks(getRoleList)
  const { addUserDetails, updateUserDetails } = useAddUpdateUserHooks(
    selectedData,
    userId,
    onCloseModal,
  )
  return (
    <div>
      <div className="d-flex justify-content-between p-4 mx-4 user-details-container">
        <div>
          <p className="user-header">{t('userRoles.user_name')}</p>
          <p className="user-data">{selectedData?.userInfo?.userName}</p>
        </div>
        <div>
          <p className="user-header">{t('userRoles.user_phone')}</p>
          <p className="user-data">{selectedData?.userInfo?.phone}</p>
        </div>
        <div>
          <p className="user-header">{t('userRoles.user_email')}</p>
          <p className="user-data">{selectedData?.userInfo?.email}</p>
        </div>
      </div>
      <div className="d-flex col-12 justify-content-between p-4">
        <div className="col-md-4 selectRole">
          <div className="role-subcontent border-bottom p-1">
            {t('userRoles.roles_selected')}
          </div>
          <div
            className="scroll-list-content"
            style={{ height: '345px', overflow: 'auto' }}
          >
            {userRoles?.map((role) => {
              return (
                <div key={role?.applicationType}>
                  <div className="selectedRoles">
                    {role?.applicationType?.toUpperCase()}
                  </div>
                  <div className="d-flex selectedBorder px-4 py-2">
                    <div className="role-subcontent mx-2">
                      {t('userRoles.role')}
                    </div>
                    <div className="role-subcontainer ms-3">
                      {role?.roleName}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div className="col-md-8 d-flex justify-content-between">
          <div className="roleBorder col-5">
            {selectedApps?.map((app) => {
              return (
                <div
                  role="button"
                  className={`border-bottom ps-4 py-1 pointer list-hauler-style ${
                    //app?.applicationCode === selectedAppCode &&
                    'selected-back-ground'
                  } `}
                  key={app?.applicationCode}
                  onClick={() => {
                    handleAppSelection(app?.applicationCode)
                  }}
                >
                  <div className="appList">
                    {app?.applicationType?.toUpperCase()}
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="labelSubContent">
                      {checkSelection(app?.applicationCode)}
                    </div>
                    <div
                      className={`${
                        checkSelection(app?.applicationCode)
                          ? 'visible'
                          : 'invisible'
                      }`}
                    >
                      <button
                        title={t('common.clear')}
                        className="btn btn-link link-button me-2"
                        aria-label="Clear"
                        onClick={() => {
                          removeSelection(app?.applicationCode)
                        }}
                      >
                        <MdOutlineCancel size={17} />
                      </button>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          <div className="col-7">
            <ATSearchBox
              name="customer"
              handleChange={queryHandler}
              onBlurHandler={() => null}
              searchInput={query}
              placeholder={t('customer.search_customers')}
            />
            <div
              className="roleBorder scroll-list-content"
              style={{ height: '345px', overflow: 'auto' }}
            >
              {selectedAppCode === applicationTypes[APP_TYPE.CUSTOMER_APP] &&
                filteredJobs(customersList)?.map((data: customersListData) => {
                  return (
                    <div
                      className="border-bottom ps-4 py-3 list-hauler-style"
                      key={data?.customerCode}
                    >
                      <ATRadioButton
                        id={data?.customerCode}
                        label={data?.customerName}
                        name="wellSite"
                        handleChange={() =>
                          handleCustomerSelection(data?.customerCode)
                        }
                        checked={data?.customerCode === selectedCustomer}
                        selectedValue={data?.customerCode}
                      />
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex px-4 pb-4 justify-content-end">
        <div>
          <ATTextButton
            title={t('common.cancel')}
            onPressHandler={() => onCloseModal()}
            isFilledButton={false}
          />
        </div>
        <div>
          <ATTextButton
            title={t('common.back')}
            onPressHandler={() => {
              backButtonHandler()
            }}
            disabled={false}
          />
        </div>
        <div>
          <ATTextButton
            title={isEdit ? t('common.update') : t('common.save')}
            onPressHandler={
              isEdit
                ? () => {
                    updateUserDetails()
                  }
                : () => {
                    addUserDetails()
                  }
            }
            disabled={selectedCustomer === ''}
          />
        </div>
      </div>
    </div>
  )
}

export default AddCustomerRoles
